import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=cb748a7a&scoped=true&lang=pug&"
import script from "./UploadFiles.vue?vue&type=script&lang=js&"
export * from "./UploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=cb748a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb748a7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb748a7a')) {
      api.createRecord('cb748a7a', component.options)
    } else {
      api.reload('cb748a7a', component.options)
    }
    module.hot.accept("./UploadFiles.vue?vue&type=template&id=cb748a7a&scoped=true&lang=pug&", function () {
      api.rerender('cb748a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autoservice/UploadFiles.vue"
export default component.exports